import React from 'react';
import PropTypes from 'prop-types';
import MaterialDialog from 'material-ui/Dialog';

const Dialog = (props) => {
    const {
        actions,
        actionsContainerStyle,
        autoScrollBodyContent,
        children,
        contentStyle,
        modal,
        onRequestClose,
        open,
        repositionOnUpdate,
        title,
    } = props;

    return (
        <MaterialDialog
            actions={ actions }
            actionsContainerStyle={ actionsContainerStyle }
            autoScrollBodyContent={ autoScrollBodyContent }
            contentStyle={ contentStyle }
            modal={ modal }
            overlayStyle={ {
                backgroundColor: 'rgba(237, 236, 236, 0.6)',
            } }
            onRequestClose={ onRequestClose }
            open={ open }
            repositionOnUpdate={ repositionOnUpdate }
            title={ title }
        >
            { children }
        </MaterialDialog>
    );
};

Dialog.propTypes = {
    actions: PropTypes.node,
    actionsContainerStyle: PropTypes.object,
    autoScrollBodyContent: PropTypes.bool,
    children: PropTypes.node,
    contentStyle: PropTypes.object,
    modal: PropTypes.bool,
    onRequestClose: PropTypes.func,
    open: PropTypes.bool,
    repositionOnUpdate: PropTypes.bool,
    title: PropTypes.node,
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/ui/dialog/Dialog.js